import { CurrentAgentCommissionDialog } from "app/pages/AgentPricing/modules/EditDialogs/state";

export function getCurrentDialog(state: any) : CurrentAgentCommissionDialog {
    return state.dialog;
}